import React from 'react';
import { useClientConfig } from '../api/clientConfig';

// Shown in the sidebar (under Logout) and, since the sidebar never renders on
// /login, again on the login page itself -- GitHub issue #45 asked for the
// copyright notice on every page including that one. The version comes from
// the server (see config.py::_read_app_version) rather than a REACT_APP_*
// build-time var, the same reasoning every other client-config value in this
// file uses: it has to reflect whichever image is actually running right now.
function AppFooter({ className = '' }) {
  const { app_version: appVersion, manual_url: manualUrl } = useClientConfig();
  const year = new Date().getFullYear();
  // Same "" until published, hide-rather-than-point-at-nothing rule Sidebar.js
  // already applies to its Help link -- the legal pages live on the manual
  // static site (GitHub issues #48/#49), not as routes in this app.
  const manualBase = manualUrl ? manualUrl.replace(/\/+$/, '') : '';

  return (
    <div className={`app-footer ${className}`.trim()}>
      <p>Version {appVersion}</p>
      <p>&copy; {year}, MediGovern, LLC.</p>
      <p>All Rights Reserved.</p>
      {manualBase && (
        <p>
          <a href={`${manualBase}/privacy-policy/`} target="_blank" rel="noopener noreferrer">
            Privacy
          </a>
          {' · '}
          <a href={`${manualBase}/terms/`} target="_blank" rel="noopener noreferrer">
            Terms
          </a>
        </p>
      )}
    </div>
  );
}

export default AppFooter;
